// src/core/common/sidebar/driverSidebar.tsx
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { all_routes } from '../router/all_routes';
import { useAuth } from '../auth/AuthProvider';
import ImageWithBasePath from '../../core/common/imageWithBasePath';
import axios from 'axios';

const DriverSidebar = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { user, isLoggedIn, setUser, setIsLoggedIn } = useAuth();
    const BASE_URL = process.env.REACT_APP_API_URL;

    const [unreadTours, setUnreadTours] = useState<number>(0);

    const handleLogout = (e: React.MouseEvent) => {
        e.preventDefault();
        localStorage.removeItem('token');
        setUser(null);
        setIsLoggedIn(false);
        navigate('/');
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token || !user?.id) return;

        const headers = { Authorization: `Bearer ${token}` };

        const fetchUnread = async () => {
            try {
                const res = await axios.get<{ totalNaoVisualizadas: number }>(
                    `${BASE_URL}/motorista/mensagens/nao-visualizadas`,
                    { headers }
                );
                setUnreadTours(res.data.totalNaoVisualizadas || 0);
            } catch (err) {
                console.error('Erro ao buscar mensagens não vistas:', err);
            }
        };

        fetchUnread();
    }, [BASE_URL, user?.id]);

    return (
        <div className="card user-sidebar mb-4 mb-lg-0 theiaStickySidebar">
            <div className="card-header user-sidebar-header">
                <div className="profile-content rounded-pill">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            {user?.foto?.url ? (
                                <img
                                    src={`${BASE_URL}/uploads/${user.foto.id}`}
                                    alt="Foto de perfil"
                                    className="img-fluid avatar avatar-lg rounded-circle flex-shrink-0 me-1"
                                    style={{ objectFit: "cover", width: "60px", height: "60px" }}
                                />
                            ) : (
                                <ImageWithBasePath
                                    src="assets/img/users/user-01.jpg"
                                    alt="image"
                                    className="img-fluid avatar avatar-lg rounded-circle me-2"
                                />
                            )}
                            <div>
                                <h6 className="fs-16 mb-0">
                                    {user?.nome || user?.email || 'Motorista'}
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card-body user-sidebar-body">
                <ul>
                    <li>
                        <span className="fs-14 text-gray-3 fw-medium mb-2">Motorista</span>
                    </li>
                    <li>
                        <Link
                            to={all_routes.driverDashboard}
                            className={`d-flex align-items-center ${location.pathname === all_routes.driverDashboard ? 'active' : ''}`}
                        >
                            <i className="isax isax-dashboard-2" />
                            Panel
                        </Link>
                    </li>
                    <li>
                        <Link
                            to={all_routes.driverTours}
                            className={`d-flex align-items-center position-relative ${location.pathname === all_routes.driverTours ? 'active' : ''}`}
                        >
                            <i className="isax isax-car" />
                            My Tours
                            {unreadTours > 0 && (
                                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                    {unreadTours}
                                </span>
                            )}
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="#"
                            className={`d-flex align-items-center ${location.pathname.includes('driver/earnings') ? 'active' : ''}`}
                        >
                            <i className="isax isax-wallet" />
                            Commissions
                        </Link>
                    </li>
                    <li>
                        <Link
                            to={all_routes.driverProfile}
                            className={`d-flex align-items-center ${location.pathname === all_routes.driverProfile ? 'active' : ''}`}
                        >
                            <i className="isax isax-profile-tick" />
                            My Profile
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/"
                            onClick={handleLogout}
                            className="d-flex align-items-center"
                        >
                            <i className="isax isax-logout" /> Exit
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default DriverSidebar;
